import React from 'react';
import { featureContent } from '@anonymizePro/mock/contents';
import FeatureCard from '@anonymizePro/components/cards/feature-card';

export default function FeatureMain() {
    return (
        <div className="w-full">
            {featureContent.map((feature) => (
                <FeatureCard key={feature.step} feature={feature} />
            ))}
        </div>
    );
}
